import { create } from 'zustand';
import { ControlId } from './controlCenter.types';
import { DEFAULT_CONTROL_ORDER } from './controlCenter.defaults';

const STORAGE_KEY = 'control-center-order';

const loadFromStorage = (): ControlId[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as ControlId[];
      // Merge with defaults to include any new controls added in updates
      const merged = [...parsed];
      for (const id of DEFAULT_CONTROL_ORDER) {
        if (!merged.includes(id)) {
          merged.push(id);
        }
      }
      return merged;
    }
    return DEFAULT_CONTROL_ORDER;
  } catch {
    return DEFAULT_CONTROL_ORDER;
  }
};

const saveToStorage = (order: ControlId[]): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(order));
  } catch {
    // Ignore storage errors
  }
};

interface ControlCenterState {
  isEditMode: boolean;
  setEditMode: (value: boolean) => void;
  controlOrder: ControlId[];
  updateOrder: (newOrder: ControlId[]) => void;
  resetOrder: () => void;
}

export const useControlCenterStore = create<ControlCenterState>((set) => ({
  isEditMode: false,
  setEditMode: (value) => set({ isEditMode: value }),

  controlOrder: loadFromStorage(),

  updateOrder: (newOrder) => {
    saveToStorage(newOrder);
    set({ controlOrder: newOrder });
  },

  resetOrder: () => {
    saveToStorage(DEFAULT_CONTROL_ORDER);
    set({ controlOrder: [...DEFAULT_CONTROL_ORDER] });
  },
}));
